import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { FilterBody, FilterProps } from "../../../hooks/filter/typing";
import { Item, ObjectGeneric } from "../../../utils/types/generals";
import { InputModel } from "../../../utils/types";
import { DownloadType } from "../../../hooks/download/useDownload";

const CalendarContext = createContext<{
    filterData: FilterBody
    setFilterPayload: Dispatch<SetStateAction<FilterProps>>
    filterSchedule: FilterBody
    externalValidation: ((data: {
        name: string;
        value: any;
        body: any;
        setFilterData: (value: SetStateAction<ObjectGeneric>) => void;
    }) => any) | undefined
    scheduleData: {
        items: {
            [x: string]: Item[];
        };
        departments: any[];
        childZones: any[];
        input: {
            [x: string]: InputModel;
        };
        getData: () => Promise<void>;
        handleItemsByExternal: ({ name, value }: {
            name: string;
            value: any;
        }) => void;
        disabledInputs: (data: {
            inputs: string[];
            value: boolean;
        }) => void;
    }
    setIdQuestionnaire: Dispatch<SetStateAction<number | null>>
    idQuestionnaire: number | null
    isLoading: boolean
    uuid: string
    typeDownload: string | undefined
    getDetailInform: ({ query, type }: {
        query?: string;
        type?: DownloadType
    }) => Promise<void>
}>(Object({}))

export const useScheduleContext = () => useContext(CalendarContext)
export { CalendarContext }